import { useState } from "react";
import { client } from "../net/client";
import { useSignal } from "../net/signal";
import { notify } from "./Dialog";
import { IRAN_CITIES, countryName } from "../game/place";

/**
 * کشور و شهر در تنظیمات.
 *
 * کشور از IP است و انتخاب نمی‌شود؛ این‌جا فقط دیده می‌شود و یک کلید پنهانش
 * می‌کند. شهر اختیاری است و فقط برای ایران، از فهرست (نه متنِ آزاد) تا دشنام
 * و شوخی به میز نرسد. همین دو ردیف در تنظیماتِ اپ هم هست.
 */
export function PlaceSettings() {
  const country = useSignal(client.country);
  const city = useSignal(client.city);
  const show = useSignal(client.showPlace);
  const [busy, setBusy] = useState(false);

  const save = async (nextCity: string, nextShow: boolean, ok: string) => {
    if (busy) return;
    setBusy(true);
    const err = await client.setPlace(nextCity, nextShow);
    setBusy(false);
    notify(err ? (err === "network" ? "به سرور وصل نشد؛ دوباره امتحان کن" : "نشد؛ دوباره امتحان کن") : ok);
  };

  return (
    <>
      <label className="row place-show" style={{ gap: 8, cursor: "pointer" }}>
        <input
          type="checkbox"
          checked={show}
          disabled={busy}
          onChange={(e) => void save(city, e.target.checked, e.target.checked ? "کشورت دیده می‌شود" : "کشورت پنهان شد")}
        />
        <span>کشورم را به بقیه نشان بده</span>
        <span className="place-cur">
          {country ? countryName(country) : "نامعلوم"}
        </span>
      </label>
      {country === "IR" && (
        <label className="row" style={{ gap: 8 }}>
          <span>شهر (اختیاری)</span>
          <select
            value={city}
            disabled={busy}
            aria-label="شهر"
            onChange={(e) => void save(e.target.value, show, e.target.value ? "شهرت ثبت شد" : "شهرت پاک شد")}
          >
            <option value="">انتخاب نمی‌کنم</option>
            {IRAN_CITIES.map((c) => <option key={c} value={c}>{c}</option>)}
          </select>
        </label>
      )}
      <div className="muted">کشور از روی اینترنتت تشخیص داده می‌شود؛ با VPN ممکن است اشتباه باشد.</div>
    </>
  );
}
